import React from "react";
import ReactDOM from "react-dom/client";
import { MotionConfig } from "framer-motion";
import App from "./App";
import "./styles/00-fonts.css";
import "./styles.css";

// Start with the intended font, so initial layout and headline animation do not
// run against a heavier fallback. A failed font keeps a stable system face.
async function mount() {
  let timeout = 0;
  const ready = await Promise.race([
    document.fonts.load('500 16px "Manrope Variable"', 'BecauseФМ0123').then(faces => faces.length > 0, () => false),
    new Promise<boolean>(resolve => { timeout = window.setTimeout(() => resolve(false), 1500); }),
  ]);
  window.clearTimeout(timeout);
  if (!ready) document.documentElement.classList.add("font-fallback");
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <MotionConfig reducedMotion="user"><App /></MotionConfig>
    </React.StrictMode>,
  );
}
void mount();
